import { NonEmptyArray } from "@visonum/network-quality-sdk";
import * as R from "ramda";

export function getLastItem<T>(arr: NonEmptyArray<T>): T;
export function getLastItem<T>(arr: T[]): T | null;
export function getLastItem<T>(arr: T[] | NonEmptyArray<T>)
{
    if (Array.isArray(arr)) {
        const v = R.last(arr);
        return R.isNil(v) ? null : v;    
    }

    if (arr.tail.length > 0) {
        return R.last(arr.tail);
    }

    return arr.head;
}
